export enum PolylineWeight {
  activeWidth = 3,
  inactiveWidth = 1
}
